// import React from "react";
// import { useLocation, useHistory } from "react-router-dom";

// const PageTitle = ({ sidebar }) => {
//   const location = useLocation();
//   const history = useHistory();
//   const currentPath = location.pathname;

//   const getBreadcrumbs = (path, items, parentName = null) => {
//     for (const item of items) {
//       if (item.path === path) {
//         return parentName ? [parentName, item.name] : [item.name];
//       }
//       if (item.route && item.route.length > 0) {
//         const childBreadcrumbs = getBreadcrumbs(path, item.route, item.name);
//         if (childBreadcrumbs.length) {
//           return parentName ? [parentName, ...childBreadcrumbs] : childBreadcrumbs;
//         }
//       }
//     }
//     return [];
//   };

//   const breadcrumbs = sidebar.length ? getBreadcrumbs(currentPath, sidebar) : [];
//   const breadcrumbTrail = breadcrumbs.length > 1 ? ["Dashboard", ...breadcrumbs] : ["Dashboard"];

//   const handleNavigateFunction = (path) => {
//     if (typeof path === "string" && path.trim() !== "") {
//       history.push(path.toLowerCase());
//     } else {
//       console.error("Invalid path provided:", path);
//     }
//   };

  
//   return (
//     <h1 className="mt-3 text-lg font-bold text-gray-700 dark:text-gray-300">
//       <nav aria-label="Breadcrumb" className="mb-2">
//         <ol className="flex space-x-2 text-sm text-gray-600 dark:text-gray-400">
//           {breadcrumbTrail
//             .filter((_, index) => index === 0 || index === breadcrumbTrail.length - 1)
//             .map((crumb, index, filteredBreadcrumbs) => (
//               <React.Fragment key={index}>
//                 <li
//                   onClick={() => handleNavigateFunction(index === 0 ? "/dashboard" : currentPath)}
//                   className="flex items-center cursor-pointer"
//                 >
//                   <span>{crumb}</span>
//                 </li>
//                 {index < filteredBreadcrumbs.length - 1 && <span className="mx-2">/</span>}
//               </React.Fragment>
//             ))}
//         </ol>
//       </nav>
//     </h1>
//   );
// };

// export default PageTitle;



import React from "react";
import { useLocation, useHistory } from "react-router-dom";

const PageTitle = ({ sidebar = [] }) => {
  const location = useLocation();
  const history = useHistory();

  const currentPath = location.pathname;

  const normalizePath = (path) => {
    if (!path || typeof path !== "string") {
      return "";
    }

    return path.toLowerCase().replace(/\/+$/, "");
  };

  const normalizedCurrentPath = normalizePath(currentPath);

  const getCurrentMenu = () => {
    if (!sidebar.length) {
      return null;
    }

    const exactMatch = sidebar.find(
      (item) => normalizePath(item.path) === normalizedCurrentPath
    );

    if (exactMatch) {
      return exactMatch;
    }

    const parentMatch = sidebar
      .filter((item) => item.path)
      .sort((a, b) => b.path.length - a.path.length)
      .find((item) => {
        const menuPath = normalizePath(item.path);

        return (
          normalizedCurrentPath.startsWith(`${menuPath}/`) ||
          normalizedCurrentPath.startsWith(menuPath)
        );
      });

    return parentMatch || null;
  };

  const currentMenu = getCurrentMenu();

  const getPageName = () => {
    if (!currentMenu) {
      const lastPart = currentPath
        .split("/")
        .filter(Boolean)
        .pop();

      if (!lastPart) {
        return "Dashboard";
      }

      return lastPart
        .replace(/[-_]/g, " ")
        .replace(/\b\w/g, (letter) => letter.toUpperCase());
    }

    if (normalizePath(currentMenu.path) === normalizedCurrentPath) {
      return currentMenu.name;
    }

    const lastPart = currentPath
      .split("/")
      .filter(Boolean)
      .pop();

    if (!lastPart) {
      return currentMenu.name;
    }

    if (/^\d+$/.test(lastPart)) {
      return currentMenu.name;
    }

    return lastPart
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  };

  const handleNavigate = (path) => {
    if (!path) {
      return;
    }

    history.push(path);
  };

  const pageName = getPageName();

  const isDashboard =
    normalizedCurrentPath === "/dashboard" ||
    normalizedCurrentPath === "/";

  return (
    <h1 className="mt-3 text-lg font-bold text-gray-700 dark:text-gray-300">
      <nav aria-label="Breadcrumb" className="mb-2">
        <ol className="flex flex-wrap items-center text-sm text-gray-600 dark:text-gray-400">
          <li
            onClick={() => handleNavigate("/dashboard")}
            className={`flex items-center ${
              isDashboard
                ? "text-gray-700 dark:text-gray-200"
                : "cursor-pointer hover:text-green-500 font-semibold"
            }`}
          >
            <span>Dashboard</span>
          </li>

          {!isDashboard && (
            <>
              <span className="mx-2 text-gray-400">/</span>

              <li className="flex items-center font-medium text-gray-700 dark:text-gray-200">
                <span>{pageName}</span>
              </li>
            </>
          )}
        </ol>
      </nav>
    </h1>
  );
};

export default PageTitle;